import { Modal } from "@wayflyer/flyui";
import type { BankAccountGroupSchema } from "bankconnect";
import { useIntl } from "react-intl";

import { useRemoveStatementAction } from "../../hooks/use-remove-statement-action";
import { MESSAGES } from "../message-definitions";
import { getGroupAccountLabel } from "../utils";

type RemoveStatementModalProps = {
  isOpen: boolean;
  onClose: () => void;
  uploadUuid: string;
  group: BankAccountGroupSchema;
  companyDomain: string;
  onRemoved: () => void;
};

export const RemoveStatementModal = ({
  isOpen,
  onClose,
  uploadUuid,
  group,
  companyDomain,
  onRemoved,
}: RemoveStatementModalProps) => {
  const intl = useIntl();
  const { removeStatement, isPending } = useRemoveStatementAction(companyDomain);
  const accountLabel = getGroupAccountLabel(intl, group);

  const handleConfirm = () => {
    removeStatement(uploadUuid, {
      wasUnassigned: false,
      onSuccess: () => {
        onRemoved();
        onClose();
      },
    });
  };

  return (
    <Modal
      testId="remove-statement-modal"
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage(MESSAGES.removeStatementLastSourceTitle, { accountLabel })}
      size="normal"
      primaryAction={{
        content: intl.formatMessage(MESSAGES.removeStatementKeepAccountAction),
        onAction: onClose,
        disabled: isPending,
      }}
      secondaryAction={{
        content: intl.formatMessage(MESSAGES.removeStatementDeleteAccountAction),
        onAction: handleConfirm,
        loading: isPending,
      }}
    >
      {intl.formatMessage(MESSAGES.removeStatementLastSourceBodyText, { accountLabel })}
    </Modal>
  );
};
